import IconButton from './IconButton';
import types from './types';
import variants from './variants';

export { types, variants };

export default IconButton;
